import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {CookieService} from 'ngx-cookie-service';
import {environment} from '../../../environments/environment';
import {ConfigService} from '../utils/config.service';

@Injectable()
export class LoginService {
    private doLoginURL = `${environment.API}${environment.RESOURCES.LOGIN}`;

    constructor(private http: Http, private cookieService: CookieService, private configService: ConfigService) {
        this.doLoginURL = `${this.configService.getBaseApiUrl}${environment.RESOURCES.LOGIN}`;
    }

    private userId = '';
    private userName = '';

    public doLogin(username: string, pwd: string): Promise<string> {// Promise<any>
        const body = {
            userName: username,
            userPass: pwd
        };

        return this.http.post(this.doLoginURL, body).toPromise()
            .then(res => {
                const response = res.json();
                if (response.token.length > 0) {
                    sessionStorage.setItem('jwt', response.token);

                    const userInfo = this.getCurrentUserInfo();

                    this.userId = userInfo.userId;
                    this.userName = userInfo.user;
                    return this.userId;
                } else {
                    return 'error';
                }
            })
            .catch(error => {
                console.error('An error occurred', error); // for demo purposes only
                return this.handleError(error);
            });
    }

    getAccessToken(): string | null {
        return sessionStorage.getItem('jwt');
    }

    getDecodedTokenClaims(): any | null {
        const token = this.getAccessToken();
        if (!token) {
            return null;
        }

        try {
            const payload = token.split('.')[1];
            const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
            const decoded = atob(base64);
            return JSON.parse(decoded);
        } catch (e) {
            return null;
        }
    }

    getCurrentUserInfo() {
        const claims = this.getDecodedTokenClaims();

        if (claims) {
            return {
                funcional: claims.funcional,
                userId: claims.userId,
                user: claims.user
            };
        } else {
            return null;
        }
    }

    public checkLogin(): boolean {
        return this.getCurrentUserInfo() !== null;
    }

    public doLogout() {
        this.cookieService.deleteAll();
        sessionStorage.clear();
        this.userId = '';
        this.userName = '';
    }

    public getUsername(): string {
        const currentInfo = this.getCurrentUserInfo();
        return currentInfo ? currentInfo.user : '';
    }

    private handleError(error: any): string {
        this.doLogout();
        return error.message || error;
    }

    public getGeoserverAuth() {
        return this.cookieService.get('gh');
    }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/services/login/login.service.ts